import script from "./BlogView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogView.vue?vue&type=script&setup=true&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=8ac1b7ca&lang=css"

const __exports__ = script;

export default __exports__